// -- Endpoints --

// comment list
export const GET_COMMENTS = '/api/:type/:userId/comment';
// comment add
export const ADD_COMMENT = '/api/:type/:userId/comment';
